import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Permissao, PermissaoDTO, UsuarioPermissaoDTO, AtribuirPermissaoRequest } from '../models/permissao.model';

@Injectable({
  providedIn: 'root'
})
export class PermissaoService {
  private apiUrl = `${environment.apiUrl}/admin/permissoes`;

  constructor(private http: HttpClient) {}

  /**
   * Lista todas as permissões disponíveis (catálogo)
   * GET /api/admin/permissoes/catalogo
   */
  listarCatalogo(): Observable<PermissaoDTO[]> {
    return this.http.get<PermissaoDTO[]>(`${this.apiUrl}/catalogo`);
  }

  /**
   * Lista permissões com status para avaliador em edital
   * Lista todas as permissões disponíveis marcando quais estão atribuídas ao avaliador no edital
   * GET /api/admin/permissoes/avaliadores/{avaliadorId}/editais/{editalId}
   */
  listarPermissoesUsuario(avaliadorId: number, editalId: number): Observable<PermissaoDTO[]> {
    return this.http.get<PermissaoDTO[]>(`${this.apiUrl}/avaliadores/${avaliadorId}/editais/${editalId}`);
  }

  /**
   * Atribui permissão a usuário em um edital
   * POST /api/admin/permissoes/atribuir
   */
  atribuirPermissao(request: AtribuirPermissaoRequest): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/atribuir`, request);
  }

  /**
   * Remove permissão de usuário em um edital
   * DELETE /api/admin/permissoes/remover
   * O backend espera um body JSON com os dados da permissão
   */
  removerPermissao(request: AtribuirPermissaoRequest): Observable<void> {
    // Usando HttpRequest para enviar body em DELETE
    const httpRequest = new HttpRequest<AtribuirPermissaoRequest>(
      'DELETE',
      `${this.apiUrl}/remover`,
      request,
      {
        reportProgress: false
      }
    );
    return this.http.request<void>(httpRequest).pipe(
      // Filtrar apenas eventos de resposta HTTP
      filter((event): event is HttpResponse<void> => event instanceof HttpResponse),
      // Mapear para void
      map(() => undefined as void)
    );
  }

  /**
   * Lista usuários com uma permissão específica em um edital
   * GET /api/admin/permissoes/editais/{editalId}/permissoes/{codigoPermissao}/usuarios
   */
  listarUsuariosComPermissao(editalId: number, codigoPermissao: string): Observable<UsuarioPermissaoDTO[]> {
    return this.http.get<UsuarioPermissaoDTO[]>(
      `${this.apiUrl}/editais/${editalId}/permissoes/${codigoPermissao}/usuarios`
    );
  }

  /**
   * Lista permissões por categoria
   * GET /api/admin/permissoes/catalogo/categoria/{categoria}
   */
  listarPorCategoria(categoria: string): Observable<PermissaoDTO[]> {
    return this.http.get<PermissaoDTO[]>(`${this.apiUrl}/catalogo/categoria/${categoria}`);
  }
}
